import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { animated, useSpring } from "@react-spring/web";
import { memo } from "react";
import { Tabs } from "./Tabs/Tabs";
export const Panel = /*#__PURE__*/ memo((param)=>{
    let { tabsBottomPadding = 20, tabs, panel } = param;
    const [props] = useSpring(()=>({
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            },
            delay: 150
        }), [
        panel
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex h-full w-auto min-w-[72px] items-start justify-start overflow-hidden border-l border-l-grey-5",
        children: [
            !!panel && /*#__PURE__*/ _jsx(animated.div, {
                className: "h-full opacity-0 sm:w-[328px] 2xl:w-[350px]",
                style: props,
                children: panel
            }),
            /*#__PURE__*/ _jsx(Tabs, {
                style: {
                    paddingBottom: tabsBottomPadding
                },
                children: tabs
            })
        ]
    });
});
Panel.displayName = "Panel";
